// useYieldThresholds — Fetches the configurable yield variance threshold from backend.
// Value is decimal (e.g. 0.01 = 1%). The backend owns the default.

import { useQuery } from 'react-query';
import productionService from '../services/productionService';

export function useYieldThresholds() {
  const { data, isLoading } = useQuery(
    'yieldThresholds',
    () => productionService.getYieldThresholds(),
    {
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
    }
  );
  return { yieldThreshold: data?.yieldThreshold ?? null, isLoading };
}
